function a(n) {
  return function(r) {
    return n(r);
  };
}
var e = a;
export {
  e as _
};
